import React, { useState } from 'react'
import { Card, Col, Container, Row, Image, Form, Button, Table } from 'react-bootstrap'
import ManagePackageService from '../services/ManagePackageService';
import { isObjectValid } from '../common/utils/validate';
import Loading from '../components/loading/Loading';
import { useNavigate } from 'react-router-dom';
import SweetAlert2, {withSwal } from 'react-sweetalert2';
import { formatDateWithoutTime, formatDateWithTime } from '../common/utils/format';


function Home() {

    const navigate = useNavigate()
  
  
    const [dataInput, setDataInput] = useState({
        username: ''
    })

    const [dataAccountInfo, setDataAccountInfo] = useState({})

    const [isLoading, setIsLoading] = useState(false)
    const [swalProps, setSwalProps] = useState({});


    return (
        <div className='home-body font-link '>

            <Container>

                <Row>
                    <Col>
                        <Card>
                            <Card.Body>
                                <label style={{ fontSize: 16, fontWeight: 'bold', textDecorationLine: 'underline' }} >ระบุเงื่อนไขการค้นหา</label>

                                <Row className='mt-4' style={{ alignItems: 'center' }}>
                                    <Col xs={3}>
                                        <label>เบอร์โทรศัพท์</label>
                                    </Col>
                                    <Col xs={4}>
                                        <Form.Control
                                            type='text'
                                            placeholder='Username'
                                            value={dataInput.username}
                                            onChange={(event) => {
                                                setDataInput(prevState => ({
                                                    ...prevState, username: event.target.value
                                                }))

                                            }}
                                        />
                                    </Col>
                                </Row>
                                <Row className='mt-4'>
                                    <div style={{ flexDirection: 'row' }}>

                                        <Button variant="primary" onClick={(e) => {

                                            onSearch(e)

                                        }}>Search</Button>


                                        <Button style={{ marginLeft: 10 }} variant="outline-secondary" onClick={() => {
                                            onReset()
                                        }}>Reset</Button>

                                    </div>

                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {isObjectValid(dataAccountInfo) &&
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Row>
                                        <Col>
                                            <label style={{ fontSize: 16, fontWeight: 'bold', textDecorationLine: 'underline' }} >ข้อมูลทั่วไป</label>

                                        </Col>
                                        <Col>
                                            <label style={{ fontSize: 16, fontWeight: 'bold', textDecorationLine: 'underline' }} >ข้อมูลแพ็คเกจ</label>

                                        </Col>
                                    </Row>
                                    <Row className='mt-3'>
                                        <Col>
                                            <Row>
                                                <Col xs={3}>
                                                    <label>ID</label>
                                                </Col>
                                                <Col>
                                                    <label className='color-text'>{dataAccountInfo.id}</label>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col>
                                            <Row>
                                                <Col xs={4}>
                                                    <label>FAHFON PLUS</label>
                                                </Col>
                                                <Col>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>


                                    <Row className='mt-1'>
                                        <Col>
                                            <Row>
                                                <Col xs={3}>
                                                    <label>ชื่อ</label>
                                                </Col>
                                                <Col>
                                                    <label className='color-text'>{dataAccountInfo.name}</label>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col>
                                            <Row>
                                                <Col xs={4}>
                                                    <label>วันหมดอายุ</label>
                                                </Col>
                                                <Col>
                                                    <label className='color-text'>{dataAccountInfo.isPackagePlus ? formatDateWithoutTime(dataAccountInfo.plusExpire) : 'ยังไม่ได้สมัครสมาชิก'}</label>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>


                                    <Row className='mt-1'>
                                        <Col>
                                            <Row>
                                                <Col xs={3}>
                                                    <label>เบอร์โทรศัพท์</label>
                                                </Col>
                                                <Col>
                                                    <label className='color-text'>{dataAccountInfo.telephone}</label>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col>
                                            <Row>
                                                <Col xs={4}>
                                                    <label>FAHFON FARM</label>
                                                </Col>
                                                <Col>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>

                                    <Row className='mt-1'>
                                        <Col>
                                            <Row>
                                                <Col xs={3}>
                                                    <label>อีเมล์</label>
                                                </Col>
                                                <Col>
                                                    <label className='color-text'>{dataAccountInfo.email}</label>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col>
                                            <Row>
                                                <Col xs={4}>
                                                    <label>วันหมดอายุ</label>
                                                </Col>
                                                <Col>
                                                    <label className='color-text'>{dataAccountInfo.isPackageFarm ? formatDateWithoutTime(dataAccountInfo.farmExpire) : 'ยังไม่ได้สมัครสมาชิก'}</label>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>

                                    <Row className='mt-1'>
                                        <Col>
                                            <Row>
                                                <Col xs={3}>
                                                    <label>วันเริ่มใช้งาน</label>
                                                </Col>
                                                <Col>
                                                    <label className='color-text'>{formatDateWithoutTime(dataAccountInfo.created)}</label>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col>

                                        </Col>
                                    </Row>


                                    <Row className='mt-1'>
                                        <Col>
                                            <Row>
                                                <Col xs={3}>
                                                    <label>วัตถุประสงค์</label>
                                                </Col>
                                                <Col>
                                                    <label className='color-text'>{dataAccountInfo.objective}</label>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col>

                                        </Col>
                                    </Row>

                                    <Row className='mt-1'>
                                        <Col>
                                            <Row>
                                                <Col xs={3}>
                                                    <label>อำเภอ</label>
                                                </Col>
                                                <Col>
                                                    <label className='color-text'>{dataAccountInfo.district}</label>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col>

                                        </Col>
                                    </Row>

                                    <Row className='mt-1'>
                                        <Col>
                                            <Row>
                                                <Col xs={3}>
                                                    <label>จังหวัด</label>
                                                </Col>
                                                <Col>
                                                    <label className='color-text'>{dataAccountInfo.province}</label>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col>

                                        </Col>
                                    </Row>

                                    <Row className='mt-4'>
                                    <label style={{ fontSize: 16, fontWeight: 'bold', textDecorationLine: 'underline' }} >ข้อมูลการชำระเงิน</label>
                                    </Row>
                                    <Row className='mt-3'>
                                        <Col>
                                            <Table striped bordered hover size="sm">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Payment Type</th>
                                                        <th>Package</th>
                                                        <th>Amount</th>
                                                        <th>Unit</th>
                                                        <th>Payment Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {isObjectValid(dataAccountInfo) && dataAccountInfo.transectionPayment.map((item, index) => {

                                                        return (
                                                            <tr key={`key-${index}`}>
                                                                <td>{index + 1}</td>
                                                                <td>{item.paymentType}</td>
                                                                <td>{item.package}</td>
                                                                <td>{item.amount}</td>
                                                                <td>{item.unit}</td>
                                                                <td>{formatDateWithTime(item.created)}</td>
                                                            </tr>
                                                        )
                                                    })}

                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                }

            </Container>


            <Loading isShow={isLoading} />

            <SweetAlert2 {...swalProps}

                didClose={() => {
                    setSwalProps({
                        show: false,
                        icon: 'info',
                        html: 'กรุณากรอกข้อมูลให้ถูกต้อง',
                        showConfirmButton: true,
                        confirmButtonColor: '#0d6efd',
                        confirmButtonText: 'OK',
                    });
                }}

                onConfirm={result => {
                    setSwalProps({
                        show: false,
                        icon: 'info',
                        html: 'กรุณากรอกข้อมูลให้ถูกต้อง',
                        showConfirmButton: true,
                        confirmButtonColor: '#0d6efd',
                        confirmButtonText: 'OK',
                    });
                }}


            >
                {/* <label>sadasdsadsa</label> */}
            </SweetAlert2>
        </div>
    )

    function onReset() {
        setDataAccountInfo({})
        setDataInput({
            username: ''
        })

    }

    async function onSearch(e) {



        if (dataInput.username === '') {
            setSwalProps({
                show: true,
                icon: 'info',
                html: 'กรุณากรอกข้อมูลให้ถูกต้อง',
                showConfirmButton: true,
                confirmButtonColor: '#0d6efd',
                confirmButtonText: 'OK',
            });

            return;

        }
        else {

            setIsLoading(true)

            let params = new URLSearchParams()

            params.append('keyword', dataInput.username)

            ManagePackageService.searchAccount(params).then(result => {

                if (result.status === 200) {
                   
                    setIsLoading(false)
                    setDataAccountInfo(result.data)
                }

            }).catch(err => {
                setIsLoading(false)

                if (err.status === 404) {
                    setSwalProps({
                        show: true,
                        icon: 'info',
                        html: 'ไม่พบข้อมูลผู้ใช้งาน',
                        showConfirmButton: true,
                        confirmButtonColor: '#0d6efd',
                        confirmButtonText: 'OK',
                    });
                }
                else if (err.status === 401) {
                    navigate('/login')
                }

            })

        }
    }



}

export default Home